import { Component, input, output } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faGlobe } from '@fortawesome/pro-duotone-svg-icons';
import { faGear, faLanguage } from '@fortawesome/pro-regular-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import { UiAdminModule } from '@eiq/ui';

@Component({
  standalone: true,
  selector: 'empathy-languages-empty',
  templateUrl: 'languages-empty.component.html',
  styleUrls: ['languages-empty.component.scss'],
  imports: [FontAwesomeModule, UiAdminModule]
})
export class LanguagesEmptyComponent {
  message = input.required<string>();
  showLanguageSettingsButton = input<boolean>(false);
  disableAddLanguage = input<boolean>(false);

  addLanguage = output();
  languageSettings = output();

  faGlobe = faGlobe;
  faPlus = faPlus;
  faLanguage = faLanguage;
  faGear = faGear;
}
